var _defs, _rect, _circle, _circle2, _circle3, _circle4, _circle5, _line, _line2, _line3, _line4, _line5, _line6, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLlm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "llmGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#10a37f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#64ffda"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 28,
    fill: "#112240"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 40,
    r: 12,
    fill: "url(#llmGrad)",
    opacity: 0.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 74,
    r: 10,
    fill: "url(#llmGrad)",
    opacity: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 74,
    r: 10,
    fill: "url(#llmGrad)",
    opacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 98,
    r: 8,
    fill: "url(#llmGrad)",
    opacity: 0.7
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 98,
    r: 8,
    fill: "url(#llmGrad)",
    opacity: 0.7
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 40,
    x2: 36,
    y2: 74,
    stroke: "#64ffda",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 40,
    x2: 92,
    y2: 74,
    stroke: "#64ffda",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 74,
    x2: 92,
    y2: 74,
    stroke: "#64ffda",
    strokeWidth: 2.5,
    strokeDasharray: "4,4"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 74,
    x2: 48,
    y2: 98,
    stroke: "#64ffda",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 92,
    y1: 74,
    x2: 80,
    y2: 98,
    stroke: "#64ffda",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 98,
    x2: 80,
    y2: 98,
    stroke: "#64ffda",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "64,18 66,26 74,28 66,30 64,38 62,30 54,28 62,26",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLlm);
export default __webpack_public_path__ + "static/media/llm.7616ae5ae5bf77de81742ccca9e14d06.svg";
export { ForwardRef as ReactComponent };